import Vue from 'vue';
import Vuex from 'vuex';
// import firebase from 'firebase';
// import firebase from '@/firebase/firestore';
import projects from './modules/projects';
import notes from './modules/notes';
import loginStatus from './modules/loginStatus';
import popupStatus from './modules/popupStatus';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    projects,
    notes,
    loginStatus,
    popupStatus,
  },
});

// 参考：https://qiita.com/ErgoFriend/items/bd1bb445e185bf45e272
